import { format } from 'date-fns';
import React, { useState, useEffect } from 'react';
import BookingModal from './BookingModal';
import Service from './Service';

const AvailableAppointments = ({ date }) => {
    const [services, setServices] = useState([]);
    const [treatment, setTreatment] = useState(null);
    const formattedDate = format(date, 'PP');

    useEffect(() => {
        fetch(`https://shielded-mountain-79864.herokuapp.com/available?date=${formattedDate}`)
            .then(res => res.json())
            .then(data => setServices(data));
    }, [])

    return (
        <div className='my-10'>
            <h4 className='text-4xl font-bold text-orange-600 text-center my-12'>There Is Our Services Product Parcesh which You Want</h4>
            <div className='grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5'>
                {
                    services.map(service => <Service
                        key={service._id}
                        service={service}
                        setTreatment={setTreatment}
                    ></Service>)
                }
            </div>
            {treatment && <BookingModal
                date={date}
                treatment={treatment}
                setTreatment={setTreatment}
            ></BookingModal>}
        </div>
    );
};

export default AvailableAppointments;